import React, {Component} from "react";
import Invoice from "./InvoiceView";
import {InvoiceService} from "../../../service/admin/invoice/InvoiceService";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {amountDataTableTemplate, percent} from "../../../utils/formatters/Numbers";
import {EDIT_PARAMETERS_ROUTE} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import {Clear, Check} from '@material-ui/icons';

export default class InvoiceContainer extends Component {
    constructor(props) {
        super(props);

        this.invoiceService = new InvoiceService();
        this.today = new Date();
        this.loading = this.loading.bind(this);
        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.getInvoice = this.getInvoice.bind(this);
        this.getInvoiceXls = this.getInvoiceXls.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.institutionsMaintenance = this.institutionsMaintenance.bind(this);
        this.onSelectionChangeTable = this.onSelectionChangeTable.bind(this);
        this.expandReduceAll = this.expandReduceAll.bind(this);
        this.clearFilters = this.clearFilters.bind(this);

        this.state = {
            isLoading: true,
            filters: {
                catInstitutionLenderFilter: {},
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
            invoiceList: [],
            expandedRows: false,
            selectedInvoice: []
        };
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    getInvoice() {
        this.loading(true);
        this.invoiceService.getInvoice(this.state.filters)
            .then(response => {
                this.setState({
                    invoiceList: response.payload,
                    selectedInvoice: [],
                });
                this.loading(false);
            });
    }

    clearFilters() {
        this.setState({
            filters: {
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
                catInstitutionLenderFilter: {}
            },
            selectedInvoice: [],
        });

    }

    onChangeFilters(event) {
        let filtersAux = this.state.filters;
        if (event.target.name === "startDate") {
            filtersAux[event.target.name] = event.target.value;
            filtersAux['finalDate'] = event.target.value;
        } else {
            filtersAux[event.target.name] = event.target.value ? event.target.value : "";
        }
        this.setState({
            filters: filtersAux,
        });
    }

    invoiceIconDataTableTemplate(rowData) {
        let icon0 = <div><Clear color={"error"}/></div>;
        let icon1 = <div><Check color={"secondary"}/></div>;
        return (rowData['facturado'] === '0' ? icon0 : icon1);
    }

    institutionsMaintenance() {
        this.props.history.push({
            pathname: EDIT_PARAMETERS_ROUTE,
        });
    }

    getInvoiceXls() {
        if (this.state.selectedInvoice.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Seleccione al menos un registro'
            });
        } else {
            this.loading(true);
            this.invoiceService.getInvoiceXLS(
                this.state.selectedInvoice,
                this.state.filters.startDate,
                this.state.filters.finalDate)
                .then(res => {
                    this.getInvoice();
                    this.loading(false);
                });
        }
    }

    handleToggle = (event) => {
        this.setState(
            {
                expandedRows: event.data,
            })
    };

    rowExpansionTemplate(data) {
        const itemsInvoice = data.listaDetalle;
        return (
            <div className="p-grid p-fluid" style={{padding: '1em'}}>
                <DataTable
                    value={itemsInvoice}
                    responsive={true}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column
                        field="folio"
                        header="Folio"
                        sortable={true}/>
                    <Column
                        field="rol"
                        header="Rol"
                        sortable={true}/>
                    <Column
                        field="cuenta"
                        header="Cuenta"
                        sortable={true}/>
                    <Column
                        field="premio"
                        header="Premio"
                        body={amountDataTableTemplate}
                        sortable={true}/>
                    <Column
                        field="porc"
                        header="Porcentaje"
                        body={(rowData) => percent(rowData['porc'] * 100, 'right')}
                        sortable={true}/>
                    <Column
                        field="importe"
                        header="Importe"
                        body={amountDataTableTemplate}
                        sortable={true}/>
                    <Column
                        field="iva"
                        header="Iva"
                        body={amountDataTableTemplate}
                        sortable={true}/>
                    <Column
                        field="total"
                        header="Total"
                        body={amountDataTableTemplate}
                        sortable={true}/>
                </DataTable>
            </div>
        );
    }

    onSelectionChangeTable(event) {
        this.setState({selectedInvoice: event.value,})
    }

    expandReduceAll() {
        if (this.state.expanded) {
            this.setState({
                expandedRows: [],
                expanded: false,
            });
        } else {
            this.setState({
                expandedRows: this.state.invoiceList,
                expanded: true,
            });
        }
    }

    formatInstitutionColumn(rowData) {
        return (rowData['institucion'] + " " + rowData['cuenta'])
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <Invoice
            isLoading={this.state.isLoading}
            loading={this.loading}
            filters={this.state.filters}
            onChangeFilters={this.onChangeFilters}
            getInvoice={this.getInvoice}
            invoiceList={this.state.invoiceList}
            invoiceIconDataTableTemplate={this.invoiceIconDataTableTemplate}
            getInvoiceXls={this.getInvoiceXls}
            institutionsMaintenance={this.institutionsMaintenance}
            expandedRows={this.state.expandedRows}
            handleToggle={this.handleToggle}
            rowExpansionTemplate={this.rowExpansionTemplate}
            selectedInvoice={this.state.selectedInvoice}
            onSelectionChangeTable={this.onSelectionChangeTable}
            expandReduceAll={this.expandReduceAll}
            clearFilters={this.clearFilters}
            messagesGrowl={messagesGrowl}
            formatInstitutionColumn={this.formatInstitutionColumn}
        />

    }
};
